import React, { useMemo } from "react";
import Prism, { type TokenStream } from "prismjs";
import "prismjs/components/prism-python";

interface PythonCodeBlockProps {
  code: string;
  maxHeight?: string;
}

function tokenClassName(token: Prism.Token): string {
  const classes = ["token", token.type];
  if (token.alias) {
    if (Array.isArray(token.alias)) {
      classes.push(...token.alias);
    } else {
      classes.push(token.alias);
    }
  }
  return classes.join(" ");
}

function renderTokenStream(stream: TokenStream): React.ReactNode {
  if (typeof stream === "string") {
    return stream;
  }
  if (stream instanceof Prism.Token) {
    return (
      <span className={tokenClassName(stream)}>
        {renderTokenStream(stream.content)}
      </span>
    );
  }
  return stream.map((item, index) => {
    if (typeof item === "string") {
      return <React.Fragment key={index}>{item}</React.Fragment>;
    }
    return (
      <span key={index} className={tokenClassName(item)}>
        {renderTokenStream(item.content)}
      </span>
    );
  });
}

const PythonCodeBlock: React.FC<PythonCodeBlockProps> = ({
  code,
  maxHeight = "12rem",
}) => {
  const highlighted = useMemo(() => {
    const tokens = Prism.tokenize(code, Prism.languages.python);
    return renderTokenStream(tokens);
  }, [code]);

  return (
    <div
      className="reward-editor-wrapper rounded-lg overflow-auto"
      style={{ maxHeight }}
    >
      <pre
        className="reward-editor p-4 m-0 text-xs"
        style={{
          fontFamily:
            "\"Fira Code\", \"JetBrains Mono\", \"Cascadia Code\", monospace",
          lineHeight: 1.6,
        }}
      >
        <code>{highlighted}</code>
      </pre>
    </div>
  );
};

export default PythonCodeBlock;
